export default "__VITE_ASSET__8M6t3pOE__"